module.exports = require("ngx-bootstrap/tabs");